var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { Component } from 'react';
import React from 'react';
import styles from './ErrorBoundary.css';
import NewRelicLogger, { ERROR_TYPE, getComponentNameFromErrorStack, getQueriesFromURL } from '../../../utils/newRelicLoghelper';
export var _logger = new NewRelicLogger();
var isProduction = process.env.NODE_ENV === 'production';
var ErrorBoundary = /** @class */ (function (_super) {
    __extends(ErrorBoundary, _super);
    function ErrorBoundary(props) {
        var _this = _super.call(this, props) || this;
        _this.logError = function (error, errorInfo) {
            var _a, _b, _c, _d;
            var data = {
                componentName: (_a = _this.props) === null || _a === void 0 ? void 0 : _a.componentName,
                isPage: (_b = _this.props) === null || _b === void 0 ? void 0 : _b.isPageLevelComponent,
                errorMessage: (_c = error) === null || _c === void 0 ? void 0 : _c.message,
                //additional data which might be useful for debugging
                errorData: getComponentNameFromErrorStack(error.stack),
                urlDetails: getQueriesFromURL(),
                errorInfo: errorInfo
            };
            _logger.logErrorEvent(data, ((_d = _this.props) === null || _d === void 0 ? void 0 : _d.isPageLevelComponent) ? ERROR_TYPE.PAGE_ERROR : ERROR_TYPE.COMPONENT_ERROR);
        };
        _this.state = {
            hasError: false,
            error: null,
            errorInfo: false
        };
        return _this;
    }
    ErrorBoundary.prototype.componentDidCatch = function (error, errorInfo) {
        this.setState({
            error: error,
            errorInfo: errorInfo,
            hasError: true
        });
        this.logError(error, errorInfo);
    };
    ErrorBoundary.prototype.render = function () {
        var _a, _b;
        if (!this.props.children)
            return null; // this is used to prevent early return or somecases where we are returning undefined
        if (!this.state.hasError)
            return this.props.children;
        /** In case of Error in a component, component will not be visible in production but will display component name along with stacktrace when using SHOW_ERROR_BOUNDARY=true flag */
        if (isProduction) {
            return null;
        }
        else {
            return ((_b = (_a = this.state) === null || _a === void 0 ? void 0 : _a.error) === null || _b === void 0 ? void 0 : _b.stack) ? (<div className={styles['eb-container']} style={{ display: 'flex', flexDirection: 'column' }}>
					<span className={styles['eb-component-name']}>{this.props.componentName}</span>
					<pre className={styles['eb-stacktrace']}>
						<code>{JSON.stringify(this.state.error.stack, null, 2)}</code>
					</pre>
				</div>) : null;
        }
    };
    return ErrorBoundary;
}(Component));
/**
 *
 * @param {string} name - Allows grouping and filterimg based on this name value
 * @param {React.Component} WrappedComponent
 * @param {boolean} [isPageLevelComponent] - Need to explicitly pass this as `true` to mark the component as page level root component. In newrelic dashboard components can then be grouped/filtered based on the `isPage` value.
 * @returns {React.Component}
 */
export function withErrorBoundary(name, WrappedComponent, isPageLevelComponent) {
    var componentName = name || WrappedComponent.name || WrappedComponent.displayName || 'Component';
    var ComponentWithErrorBoundary = /** @class */ (function (_super) {
        __extends(ComponentWithErrorBoundary, _super);
        function ComponentWithErrorBoundary(props) {
            return _super.call(this, props) || this;
        }
        ComponentWithErrorBoundary.prototype.render = function () {
            var _a = this.props, forwardedRef = _a.forwardedRef, rest = __rest(_a, ["forwardedRef"]);
            return (<ErrorBoundary componentName={componentName} isPageLevelComponent={isPageLevelComponent}>
					{forwardedRef ? <WrappedComponent {...rest} ref={forwardedRef}/> : <WrappedComponent {...rest}/>}
				</ErrorBoundary>);
        };
        return ComponentWithErrorBoundary;
    }(React.Component));
    return React.forwardRef(function (props, ref) {
        if (!ref) {
            return <ComponentWithErrorBoundary {...props}/>;
        }
        return <ComponentWithErrorBoundary {...props} forwardedRef={ref}/>;
    });
}
export default ErrorBoundary;
